import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

const ImageButton = ({ text, onClick, icon, isDelete, style }) => {
  return (
    <div
      className={`image-btn ${isDelete && isDelete}`}
      onClick={onClick && onClick}
      style={style && style}
    >
      <div className="icon">
        <FontAwesomeIcon icon={icon} />
      </div>
      {text && <p>{text}</p>}
    </div>
  );
};

export default ImageButton;
